export default (number?: number | null, text = '') => {
  if (!number) return '';
  if (number === 1) return `${number} ${text}`;
  return `${number} ${text}s`;
};
